export const BASE_URLS = {
  baseUrlIFT:
    process.env.NEXT_PUBLIC_BASE_URL_IFT || "https://interflight.st-beta.dev",
  baseUrlCDN: process.env.NEXT_PUBLIC_BASE_URL_CDN || "https://fs.snapptrip.com"
};

export const APIs = {
  VisaTypes: `${BASE_URLS.baseUrlIFT}/api/visa/v1/visa_type`,
  VisaOrder: `${BASE_URLS.baseUrlIFT}/api/visa/v1/order`,
  VisaPriceTable: `${BASE_URLS.baseUrlIFT}/api/visa/v1/price_table`,
  OTP: `${BASE_URLS.baseUrlIFT}/api/visa/v1/otp`
};
